import React, { FunctionComponent } from 'react';

import { shouldShowChatsBlockedAccountState } from '@constants/accountStates';
import useTranslate from '@hooks/useTranslate';
import css from './AccountStateTag.module.less';

interface AccountStateTagProps {
  accountState?: string | null;
  enable?: boolean;
  banEndedAt?: string | null;
}

const AccountStateTag: FunctionComponent<AccountStateTagProps> = ({
  accountState,
  enable,
  banEndedAt,
}) => {
  const content = useTranslate();

  if (!shouldShowChatsBlockedAccountState({ accountState, enable, banEndedAt })) {
    return null;
  }

  return <span className={css.tag}>{content.chatBlocked}</span>;
};

export default AccountStateTag;
